import { useBreakpointValue } from "@gluestack-style/react";
import { zodResolver } from "@hookform/resolvers/zod";
import { SelectTransactionItemProps } from "@repo/core/components/core/SelectTransactionsList/components/SelectTransactionItem/types";
import useToast from "@repo/core/components/core/Toast";
import {
  TransactionItemStatusEnum,
  TransactionItemTypeEnum
} from "@repo/core/constants/transactions";
import { ReceiptTypeEnum } from "@repo/core/enums/receipts";
import { useNavigation } from "@repo/core/hooks/useNavigation";
import { ROUTES } from "@repo/core/routes";
import { TransactionItemModel } from "@repo/core/services/entities/Transactions";
import { apiInstance } from "@repo/core/services/instances/api";
import { TransactionsResource } from "@repo/core/services/resources/transactions";
import { Z } from "@repo/core/utils/zod.utils";
import { useQuery } from "@tanstack/react-query";
import { useMemo, useState } from "react";
import { useForm } from "react-hook-form";

const transactionsResource = new TransactionsResource(apiInstance);

const formSchema = Z.object({
  lngAutorizacao: Z.number()
});

type FormType = Z.infer<typeof formSchema>;

export const SecondCopyOfReceiptOptionsController = () => {
  const isMobile = useBreakpointValue({ base: true, md: false });
  const { back, push } = useNavigation();
  const toast = useToast();

  const [receiptType, setReceiptType] = useState<ReceiptTypeEnum>(
    ReceiptTypeEnum.CLIENT
  );

  const {
    setValue,
    handleSubmit,
    formState: { isValid, isSubmitting }
  } = useForm<FormType>({
    resolver: zodResolver(formSchema)
  });

  const [selectedTransaction, setSelectedTransaction] = useState("");

  const { data: transactionsData, isFetching } = useQuery({
    queryKey: ["findTransactionsDay"],
    queryFn: () => transactionsResource.findTransactions()
  });

  const transactionsOptions: SelectTransactionItemProps[] = useMemo(() => {
    let transactions: TransactionItemModel[] = transactionsData?.data || [];

    transactions = transactions.filter(
      (item) =>
        (item.strTipo === TransactionItemTypeEnum.COMPRA ||
          item.strTipo === TransactionItemTypeEnum.SAQUE) &&
        item.strSituacao !== TransactionItemStatusEnum.CANCELADO
    );

    return (
      transactions?.map((item) => ({
        authorizationId: item.lngAutorizacao!,
        card: `****${item.strCartaoPlastico?.split(".")[3]}`,
        operation: item.strTipo!,
        value: item.dblValor!
      })) || ([] as SelectTransactionItemProps[])
    );
  }, [transactionsData]);

  const onSubmit = handleSubmit(async (formData) => {
    try {
      const { lngAutorizacao } = formData;

      const { data } =
        await transactionsResource.getProofOfTransaction(lngAutorizacao);

      if (data.cnpj) {
        push(ROUTES.secondCopyOfReceipt, data);
      }
    } catch (error) {
      console.error("Erro ao buscar comprovante", error);
      toast.error(
        "Erro ao buscar comprovante. Confira os dados e tente novamente!"
      );
    }
  });

  const handleSelectReceiptType = (type: ReceiptTypeEnum) => {
    setReceiptType(type);
  };
  const handleOnChangeTransaction = (value: string) => {
    setSelectedTransaction(value);
    setValue("lngAutorizacao", parseInt(value), {
      shouldValidate: true
    });
  };

  return {
    back,
    isMobile,
    isValid,
    isSubmitting,
    receiptType,
    handleSelectReceiptType,
    handleOnChangeTransaction,
    onSubmit,
    transactionsOptions,
    isFetching,
    selectedTransaction
  };
};
